// Dynamic Diesels — Article share: copy-link button.
// Copies the current article URL to the clipboard and flashes a confirmation.

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-copy-link]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const url = window.location.href;
        try {
          await navigator.clipboard.writeText(url);
        } catch (e) {
          // Fallback for older browsers
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) { /* no-op */ }
          document.body.removeChild(ta);
        }
        btn.classList.add('is-copied');
        const icon = btn.querySelector('iconify-icon');
        const prev = icon ? icon.getAttribute('icon') : null;
        if (icon) icon.setAttribute('icon', 'material-symbols:check');
        setTimeout(() => {
          btn.classList.remove('is-copied');
          if (icon && prev) icon.setAttribute('icon', prev);
        }, 1600);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
